import React from 'react';
import { MobileContainer } from '@components/organism/MobileContainer';
import { MyVehiclesData } from '@components/molecules/MyVehiclesData';

export function MyVehicles() {
    return (
        <MobileContainer>
            <MyVehiclesData />
        </MobileContainer>
    );
}
